<script>
import resources from './resources'

export default {
  name: 'professional-companies-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Cadastro de Estabelecimento", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          medibook-alert-custom(
            :show='show',
            @close='show = false',
            title='Perfeito',
            type='sa-success',
            message='Estabelecimento alterado com sucesso.',
            :buttonsNext='nextStepButtonIsCompanyAddresses',
            v-if="beenUpdated")
          .col-xs-12.white-bg
            .row
              .col-xs-12
                div.col-sm-12
                  .accordion.cadastro
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-1', data-parent='.cadastro')
                        |INFORMAÇÕES ADMINISTRATIVAS DO ESTABELECIMENTO
                      .collapsible-1.collapse.in
                        .panel-body
                          // Is professional
                          .col-xs-12.col-sm-4.margin-bottom(v-if=("!userIsCompany"))
                            f-document(
                              label="CPF",
                              v-model="company.document",
                              name="document",
                              :errors="errors['document']",
                              :disabled="false")

                          // Is Company
                          .col-xs-12.col-sm-4.margin-bottom(v-if=("userIsCompany"))
                            label CNPJ
                            f-document(
                              :label="country_register",
                              v-model="company.document",
                              name="document",
                              :errors="errors['document']",
                              :disabled="true")

                          .col-xs-12.col-sm-8.margin-bottom
                            v-input(:status="$v.company.name.$error ? 'error' : null")
                              f-text(
                                label="Razão Social ou Nome Completo",
                                v-model="company.name",
                                name="name",
                                :errors="errors['name']")

                        .panel-body
                            .col-xs-12.col-sm-4.margin-bottom
                              v-input(:status="$v.company.type.$error ? 'error' : null")
                                f-select(
                                label="Ambiente de Atendimento",
                                name="type",
                                v-model="company.type",
                                  :options="typeOptions",
                                  :searchable="false",
                                  :errors="errors['type']")

                            .col-xs-12.col-sm-8.margin-bottom
                              v-input(:status="$v.company.slug.$error ? 'error' : null")
                                f-text(
                                  label="Nome para Divulgação",
                                  v-model="company.slug",
                                  name="slug",
                                  :errors="errors['slug']")

                        .painel-body
                            .col-xs-12.col-sm-12.margin-bottom
                              v-input(:status="$v.company.email.$error ? 'error' : null")
                                f-email(
                                label="Endereço de Email",
                                v-model="company.email",
                                name="email",
                                :errors="errors['email']")

                            .col-xs-4
                              v-input(:status="$v.company.contact.$error ? 'error' : null")
                                f-email(
                                label="Contato",
                                v-model="company.contact",
                                name="contact",
                                :errors="errors['contact']")

                            .col-xs-4
                              v-input(:status="$v.company.phone.$error ? 'error' : null")
                                label Telefone
                                f-phone(
                                v-model="company.phone",
                                name="phone",
                                :errors="errors['phone']")

                            .col-xs-4
                              v-input(:status="$v.company.mobile.$error ? 'error' : null")
                                label Celular
                                f-phone(
                                v-model="company.mobile",
                                name="mobile",
                                :errors="errors['mobile']")
                              //-- Removido devido ao novo modulo
                              //--.row
                                .col-xs-12
                                  f-file-text(v-if="!company.attachment.uuid", :label="'Anexar ' + country_register"
                                   v-model="company.attachment",
                                   name='attachment',
                                   :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                              button.btn.save.pull-right.btn-editor(@click.prevent="doSave()")
                                span.icon 
                                |  Salvar Alterações

                    .panel(v-if="userIsCompany")
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-3', data-parent='.cadastro')
                        | INFORMAÇÕES COMPLEMENTARES
                      .collapsible-3.collapse
                        .panel-body

                            f-editor(v-model="company.bio")
                            br
                            button.btn.save.pull-right.btn-editor(@click.prevent="doSave()")
                              span.icon 
                              |  Salvar Alterações
                    .panel(v-if="userIsCompany")
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-4', data-parent='.cadastro')
                        | PALAVRAS CHAVE
                      .collapsible-4.collapse
                        .panel-body
                            tags()
</template>
<style scoped>
  .panel-body {
    padding: 0px;
  }
  .margin-bottom {
    margin-bottom: 30px;
  }

  @media screen and (max-width: 767px){
    .btn-editor {
      padding: 6px 2%;
      width: 98%;
      margin: 45px 0px;
  }
  }
</style>



// WEBPACK FOOTER //
// src/app/professional/company/companies/form/form.vue